// NOTE: This default first-month membership coupon changes periodically.
// If you need another type of discount, create a new constant and update the
// getCouponCodeForPlan function.
export const PUBLIC_MEMBERSHIP_20_OFF_COUPON_CODE = "MEMBER20";
export const PUBLIC_MEMBERSHIP_20_OFF_SAVINGS_AMOUNT_CENTS = 2000;
export const LEGACY_PUBLIC_MEMBERSHIP_COUPON_CODE = "MEMBER40";

// Keep legacy $40 coupon codes for attribution links created before this offer.
export const LEGACY_40_DOLLARS_OFF_COUPON_CODES = [
  LEGACY_PUBLIC_MEMBERSHIP_COUPON_CODE,
  "BTS40",
  "WINTER40",
  "NEWYEAR",
];
export const LEGACY_40_DOLLARS_OFF_SAVINGS_AMOUNT_CENTS = 4000;

export function getPublicMembershipOffer(isTwentyDollarOfferEnabled: boolean): {
  couponCode: string;
  savingsAmountCents: number;
} {
  return isTwentyDollarOfferEnabled
    ? {
        couponCode: PUBLIC_MEMBERSHIP_20_OFF_COUPON_CODE,
        savingsAmountCents: PUBLIC_MEMBERSHIP_20_OFF_SAVINGS_AMOUNT_CENTS,
      }
    : {
        couponCode: LEGACY_PUBLIC_MEMBERSHIP_COUPON_CODE,
        savingsAmountCents: LEGACY_40_DOLLARS_OFF_SAVINGS_AMOUNT_CENTS,
      };
}

// If the referrer attribution has a coupon code, use it. Otherwise, use the a default coupon code.
// Dependency injection for referrer attribution coupon to avoid potential circular dependency issues.
export function getCouponCodeForPlan({
  referrerAttributionCouponCode,
  currentUser,
}: {
  referrerAttributionCouponCode?: string | null;
  currentUser?: {
    hasEverSubscribed: boolean;
  } | null;
}) {
  if (referrerAttributionCouponCode) {
    return referrerAttributionCouponCode;
  }
  // Don't apply any coupons below if the user has subscribed before.
  if (currentUser?.hasEverSubscribed) {
    return null;
  }

  return null;
}

export function getSavingsAmountCentsForCouponCode(
  couponCode: string | null,
  _priceAmountCents: number,
): number {
  if (!couponCode) {
    return 0;
  }
  if (couponCode === PUBLIC_MEMBERSHIP_20_OFF_COUPON_CODE) {
    return PUBLIC_MEMBERSHIP_20_OFF_SAVINGS_AMOUNT_CENTS;
  }
  if (LEGACY_40_DOLLARS_OFF_COUPON_CODES.includes(couponCode)) {
    return LEGACY_40_DOLLARS_OFF_SAVINGS_AMOUNT_CENTS;
  }

  throw new Error(
    `Called getSavingsAmountCentsForCouponCode with invalid coupon code: ${couponCode}`,
  );
}
